import React, { useState, useEffect, useContext } from "react"
import { Grid, List, ListItemButton, ListItemIcon, ListItemText, Checkbox, Button, Paper, CardHeader } from '@mui/material'
import { BufferService, LoadingContext } from "../M_Utils"

export function M_TransferList({ header, value = [], setValue, allItems: allItemsProp, entity, field, valueIdField, disabled, filter }) {
    const [allItems, setAllItems] = useState([])
    const [checked, setChecked] = useState([])
    const ctx = useContext(LoadingContext)

    const normalizeFilterQuery = (filterValue) => {
        const trimmed = filterValue?.trim()
        if (!trimmed) return ''
        if (trimmed.startsWith('?')) return trimmed
        if (trimmed.startsWith('filter=') || trimmed.startsWith('$filter=')) return `?${trimmed}`
        if (
            trimmed.includes(' eq ') ||
            trimmed.includes(' ne ') ||
            trimmed.includes(' gt ') ||
            trimmed.includes(' ge ') ||
            trimmed.includes(' lt ') ||
            trimmed.includes(' le ') ||
            trimmed.includes(' contains(')
        ) return `?filter=${trimmed}`

        return `?${trimmed}`
    }

    useEffect(() => {
        if (entity && !allItemsProp) {
            ctx?.setIsLoad?.(true)
            const bufferService = new BufferService(entity)
            const normalizedFilter = normalizeFilterQuery(filter)
            const request = normalizedFilter ? bufferService.filter(normalizedFilter) : bufferService.get()

            request.then(res => {
                setAllItems(res?.Items || res || [])
                ctx?.setIsLoad?.(false)
            }).catch(() => ctx?.setIsLoad?.(false))
        }
    }, [entity, allItemsProp, filter])

    useEffect(() => {
        if (allItemsProp) setAllItems(allItemsProp)
    }, [allItemsProp])

    const left = allItems.filter(item => !value.some(v => String(v[valueIdField]) === String(item[valueIdField])))
    const right = value

    const leftChecked = checked.filter(c => left.some(l => l[valueIdField] === c[valueIdField]))
    const rightChecked = checked.filter(c => right.some(r => r[valueIdField] === c[valueIdField]))

    const handleToggle = (item) => () => {
        const isChecked = checked.some(c => c[valueIdField] === item[valueIdField])
        setChecked(isChecked ? checked.filter(c => c[valueIdField] !== item[valueIdField]) : [...checked, item])
    }

    const moveRight = () => {
        setValue([...value, ...leftChecked])
        setChecked(checked.filter(c => !leftChecked.includes(c)))
    }
    const moveLeft = () => {
        setValue(value.filter(v => !rightChecked.some(r => r[valueIdField] === v[valueIdField])))
        setChecked(checked.filter(c => !rightChecked.includes(c)))
    }

    const actionButtonSx = {
        my: 0.4,
        minWidth: 44,
        borderColor: 'var(--color-red-dark)',
        color: 'var(--color-red-dark)',
    }

    const customList = (title, items) => (
        <Paper
            elevation={0}
            sx={{
                width: '100%',
                maxWidth: 340,
                minWidth: 250,
                height: 320,
                display: 'flex',
                flexDirection: 'column',
                border: '2px solid var(--color-red-dark)',
                borderRadius: 2,
            }}
        >
            <CardHeader
                sx={{
                    px: 2,
                    py: 1,
                    borderBottom: '1px solid var(--color-red)',
                    color: 'var(--color-dark)',
                }}
                title={title}
                titleTypographyProps={{ variant: 'subtitle2', fontWeight: 'bold' }}
            />
            <List dense sx={{ flexGrow: 1, overflow: 'auto' }}>
                {items.map((item) => (
                    <ListItemButton
                        key={item[valueIdField]}
                        onClick={handleToggle(item)}
                        disabled={disabled}
                        sx={{ py: 0.2, '&:hover': { backgroundColor: 'var(--color-red-light)' } }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <Checkbox
                                size="small"
                                checked={checked.some(c => c[valueIdField] === item[valueIdField])}
                                sx={{ color: 'var(--color-red-dark)', '&.Mui-checked': { color: 'var(--color-red-dark)' } }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={item[field]}
                            primaryTypographyProps={{ variant: 'body2', color: 'var(--color-dark)' }}
                        />
                    </ListItemButton>
                ))}
            </List>
        </Paper>
    )

    return (
        <Grid container spacing={1.5} justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
            <Grid item xs={12} md="auto" sx={{ display: 'flex', justifyContent: 'center' }}>
                {customList("Disponiveis", left)}
            </Grid>
            <Grid item xs={12} md="auto">
                <Grid container direction="column" alignItems="center">
                    <Button sx={actionButtonSx} variant="outlined" size="small" onClick={() => { setValue([...value, ...left]); setChecked([]); }} disabled={left.length === 0 || disabled}>
                        {'>>'}
                    </Button>
                    <Button sx={actionButtonSx} variant="outlined" size="small" onClick={moveRight} disabled={leftChecked.length === 0 || disabled}>
                        {'>'}
                    </Button>
                    <Button sx={actionButtonSx} variant="outlined" size="small" onClick={moveLeft} disabled={rightChecked.length === 0 || disabled}>
                        {'<'}
                    </Button>
                    <Button sx={actionButtonSx} variant="outlined" size="small" onClick={() => { setValue([]); setChecked([]); }} disabled={right.length === 0 || disabled}>
                        {'<<'}
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12} md="auto" sx={{ display: 'flex', justifyContent: 'center' }}>
                {customList(header, right)}
            </Grid>
        </Grid>
    )
}
